import { BargainPriceItem } from '../../../models/bargain-price-item.entity'
import { getRBPStringId } from '../../../page/main/main-page-states'
import http, { BASE_URL_3 } from '../../http'


const dishSoldOutApi = {
    // *********************
    // 菜品沽清
    // *********************
    /**
     * 获取菜品沽清
     * 根据id/名称模糊搜索沽清`
     */
    async getDishSoldOut(): Promise<BargainPriceItem[]> {
        return await http.get(`${BASE_URL_3}/bargain_price_item/${getRBPStringId()}`)
    },
    /**
     * 创建菜品沽清
     */
    async postDishSoldOut(params: BargainPriceItem[]): Promise<any> {
        return await http.post(`${BASE_URL_3}/bargain_price_item/${getRBPStringId()}`, params)
    },
    /**
     * 编辑菜品沽清
     */
    async patchDishSoldOut(id: string, params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/bargain_price_item/${id}/${getRBPStringId()}`, params)
    },
    /**
     * 删除菜品沽清
     */
    async delDishSoldOut(params: number[]): Promise<any> {
        return await http.delete(`${BASE_URL_3}/bargain_price_item/${getRBPStringId()}`, {
            data: params
        })
    },
    /**
     * 重置沽清菜品
     */
    async patchDishBargainNum(params: { bargainIds: number[] }): Promise<any> {
        return await http.patch(`${BASE_URL_3}/bargain_num_cur/${getRBPStringId()}`, params)
    },
}
export default dishSoldOutApi;